module.exports = __webpack_public_path__ + "static/img/5en.f22bde2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/5en.png
// module id = rEAQ
// module chunks = 0